import _slicedToArray from "/drone/src/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useEffect } from 'react';
import { RESIZE_OBSERVER_SUPPORTED } from '../../../system/util/compatibility';
export var usePanelWidth = function usePanelWidth(containerRef, dropdownRef) {
  useEffect(function () {
    var observer = null;

    if (RESIZE_OBSERVER_SUPPORTED && dropdownRef.current) {
      observer = new ResizeObserver(function (entries) {
        var _entries = _slicedToArray(entries, 1),
            containerEntry = _entries[0];

        var _containerEntry$targe = containerEntry.target.getBoundingClientRect(),
            containerNodeWidth = _containerEntry$targe.width;

        if (dropdownRef.current) {
          dropdownRef.current.style.width = "".concat(containerNodeWidth, "px");
        }
      });
      observer.observe(containerRef.current);
    }

    return function () {
      if (observer) {
        observer.disconnect();
      }
    };
  }, [containerRef.current, dropdownRef.current]);
};